/**
 * Motowheeler widgets — sale (per-key), cookie, size guide, wishlist, recently viewed
 */
(() => {
  const doc = document;

  /* Size guide modal */
  const modal = doc.querySelector('[data-size-guide-modal]');
  if (modal) {
    const open = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      doc.body.classList.add('drawer-open');
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      doc.body.classList.remove('drawer-open');
    };
    modal.querySelectorAll('[data-modal-close]').forEach((el) => el.addEventListener('click', close));
    doc.addEventListener('click', (e) => {
      const t = e.target.closest('[data-size-guide], .option-guide');
      if (!t) return;
      e.preventDefault();
      open();
    });
    doc.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* Sale popup — separate session keys per offer type */
  const sale = doc.querySelector('[data-sale-popup]');
  if (sale) {
    const key = sale.getAttribute('data-sale-key') || 'mw_sale_seen';
    if (!sessionStorage.getItem(key)) {
      sale.hidden = false;
      const closeSale = () => {
        sale.classList.remove('is-open');
        sessionStorage.setItem(key, '1');
        setTimeout(() => {
          sale.hidden = true;
        }, 400);
      };
      setTimeout(() => sale.classList.add('is-open'), 1800);
      sale.querySelector('[data-sale-close]')?.addEventListener('click', closeSale);
      sale.addEventListener('click', (e) => {
        if (e.target === sale) closeSale();
      });
    }
  }

  /* Cookie bar */
  const cookie = doc.querySelector('[data-cookie-bar]');
  if (cookie && !localStorage.getItem('mw_cookie_ok')) {
    cookie.hidden = false;
    requestAnimationFrame(() => cookie.classList.add('is-open'));
    cookie.querySelector('[data-cookie-ok]')?.addEventListener('click', () => {
      localStorage.setItem('mw_cookie_ok', '1');
      cookie.classList.remove('is-open');
      setTimeout(() => cookie.remove(), 400);
    });
  }

  /* Wishlist — heart only; saved list in drawer */
  const WISH_KEY = 'mw_wishlist_v2';
  const WISH_LEGACY = 'mw_wishlist';

  const getWish = () => {
    try {
      let raw = JSON.parse(localStorage.getItem(WISH_KEY) || 'null');
      if (!raw) {
        const legacy = JSON.parse(localStorage.getItem(WISH_LEGACY) || '[]');
        raw = (legacy || []).map((id) => (typeof id === 'object' ? id : { id: String(id) }));
        if (raw.length) localStorage.setItem(WISH_KEY, JSON.stringify(raw));
      }
      return Array.isArray(raw) ? raw : [];
    } catch {
      return [];
    }
  };

  const setWish = (items) => localStorage.setItem(WISH_KEY, JSON.stringify(items));

  const renderWishDrawer = () => {
    const list = doc.querySelector('[data-wish-list]');
    if (!list) return;
    const items = getWish();
    if (!items.length) {
      list.innerHTML = `<div class="empty-state" data-wish-empty><p>Tap ♥ on products to save them here.</p></div>`;
      return;
    }
    list.innerHTML = `<ul class="mw-wish-drawer__items">${items
      .map((p) => {
        const title = p.title || 'Saved item';
        const url = p.url || '#';
        const img = p.image
          ? `<img src="${p.image}" alt="" width="72" height="72" loading="lazy">`
          : `<span class="mw-wish-drawer__ph">♥</span>`;
        const price = p.price ? `<strong>${p.price}</strong>` : '';
        return `<li class="mw-wish-drawer__item">
          <a href="${url}" class="mw-wish-drawer__thumb">${img}</a>
          <div class="mw-wish-drawer__meta">
            <a href="${url}">${title}</a>
            ${price}
          </div>
          <button type="button" class="mw-wish-drawer__remove" data-wishlist-toggle data-product-id="${p.id}" aria-label="Remove">×</button>
        </li>`;
      })
      .join('')}</ul>`;
  };

  const syncWishButtons = () => {
    const items = getWish();
    const ids = items.map((x) => String(x.id));
    doc.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = String(btn.getAttribute('data-product-id') || '');
      const on = ids.includes(id);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? 'Saved' : 'Save');
    });
    doc.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = String(items.length);
      el.hidden = items.length === 0;
    });
    renderWishDrawer();
  };

  doc.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = String(btn.getAttribute('data-product-id') || '');
    if (!id) return;
    let items = getWish();
    if (items.some((x) => String(x.id) === id)) {
      items = items.filter((x) => String(x.id) !== id);
    } else {
      items.unshift({
        id,
        url: btn.getAttribute('data-wish-url') || '',
        title: btn.getAttribute('data-wish-title') || 'Saved',
        image: btn.getAttribute('data-wish-image') || '',
        price: btn.getAttribute('data-wish-price') || '',
      });
    }
    setWish(items);
    syncWishButtons();
  });
  syncWishButtons();
  doc.addEventListener('cart:updated', syncWishButtons);
  /* Recently viewed */
  const RV_KEY = 'mw_recent';
  const productJson = doc.querySelector('[data-recent-product]');
  if (productJson) {
    try {
      const item = JSON.parse(productJson.textContent);
      let list = [];
      try {
        list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      } catch {
        list = [];
      }
      list = list.filter((x) => x.id !== item.id);
      list.unshift(item);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    } catch {
      /* ignore */
    }
  }

  const mount = doc.querySelector('[data-recently-viewed]');
  if (mount) {
    let list = [];
    try {
      list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    } catch {
      list = [];
    }
    const current = mount.getAttribute('data-exclude-id');
    list = list.filter((x) => String(x.id) !== String(current)).slice(0, 4);
    if (!list.length) {
      mount.hidden = true;
    } else {
      mount.hidden = false;
      const grid = mount.querySelector('[data-recent-grid]');
      if (grid) {
        grid.innerHTML = list
          .map(
            (p) => `<a class="mw-recent__card" href="${p.url}">
              ${p.image ? `<img src="${p.image}" alt="" width="120" height="120" loading="lazy">` : ''}
              <span>${p.title}</span>
              <strong>${p.price || ''}</strong>
            </a>`
          )
          .join('');
      }
    }
  }
})();
